<style>
  section {
    padding: 8rem 1.5rem;
    border-top: 1px solid var(--separator);
  }

  .container {
    max-width: 1280px;
    margin: 0 auto;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 3rem;
  }

  h2 {
    font-family: "Bodoni Moda", serif;
    font-size: 1.875rem;
    font-style: italic;
  }

  .header-label {
    font-family: "Inter", sans-serif;
    color: var(--muted);
    font-size: 0.625rem;
    letter-spacing: 0.1em;
    text-transform: uppercase;
  }

  .grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.25rem;
  }

  .grid-item {
    aspect-ratio: 4/5;
    background: radial-gradient(circle at center, #2a2a2a 0%, #1a1a1a 100%);
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  .grid-item img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.7;
    filter: grayscale(100%);
    transition: all 700ms cubic-bezier(0.25, 1, 0.5, 1);
  }

  .grid-item:hover img {
    opacity: 1;
    filter: grayscale(0%);
    transform: scale(1.02);
  }

  .grid-item span {
    position: absolute;
    bottom: 0.5rem;
    left: 0.5rem;
    font-size: 0.5rem;
    font-family: "Inter", sans-serif;
    color: white;
    opacity: 0;
    transition: opacity 300ms;
    padding: 2px;
  }

  .grid-item:hover span {
    opacity: 1;
  }

  .archive-link {
    margin-top: 4rem;
    text-align: center;
  }

  .archive-link a {
    display: inline-block;
    font-family: "Inter", sans-serif;
    font-size: 0.75rem;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--muted);
    text-decoration: none;
    border-bottom: 1px solid transparent;
    padding-bottom: 0.25rem;
    transition: all 300ms;
  }

  .archive-link a:hover {
    color: var(--ink);
    border-bottom-color: var(--ink);
  }

  @media (min-width: 768px) {
    section {
      padding: 8rem 3rem;
    }

    .grid {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  @media (min-width: 1024px) {
    section {
      padding: 8rem 6rem;
    }
  }
</style>

<script>
  let { lightboxItems = $bindable([]), openLightbox = $bindable(() => {}) } =
    $props();

  const images = [
    "image8.jpg",
    "image2.jpg",
    "image5.jpg",
    "image6.jpg",
    "image10.jpg",
    "image23.jpg",
    "image12.jpg",
    "image13.jpg",
    "image14.jpg",
    "image15.jpg",
    "image16.jpg",
    "image19.jpg",
    "image20.jpg",
    "image21.jpg",
    "image4.jpg",
    "image7.jpg",
    "image9.jpg",
    "image11.jpg",
    "image3.jpg",
    "image22.jpg",
  ];

  const startIndex = lightboxItems.length;
  const imageIndices = images.map((_, i) => startIndex + i);
  lightboxItems = [
    ...lightboxItems,
    ...images.map((filename, i) => ({
      type: "image",
      filename,
      alt: `Frame ${i + 1}`,
    })),
  ];
</script>

<section>
  <div class="container">
    <div class="header">
      <h2>Gallery</h2>
      <span class="header-label">Selected Photos</span>
    </div>

    <div class="grid">
      {#each images as filename, i}
        <div
          class="grid-item contact-sheet-item"
          onclick={() => openLightbox(imageIndices[i])}
        >
          <img
            src="./thumb_images/{filename}"
            alt="Frame {i + 1}"
            loading="lazy"
          />
          <span>{String(i + 1).padStart(2, "0")}</span>
        </div>
      {/each}
    </div>
  </div>
</section>
